import { FC, useEffect, useState } from "react";
import { CalendarCarousel } from "../../../components/CalendarCarousel";
import { TeamContext } from "../../../types/common";
import { getUrlByContext } from "../../../utils";
import { getActual } from "../../../api/transport/fixturesTransport";
import { MatchInfoShort } from "../../../types/fixtures";
import { Link } from "react-router";
import { WidgetTitle } from "../../../components/WidgetTitle";

interface CalendarCarouselWidgetProps {
    seasonId: number;
    teamId?: number;
    teamName?: TeamContext;
}

export const CalendarCarouselWidget: FC<CalendarCarouselWidgetProps> = ({
    teamName,
}) => {
    const [mathcList, setMatchList] = useState<MatchInfoShort[]>([]);

    useEffect(() => {
        getActual(teamName).then((data) => {
            setMatchList(data);
        });
    }, [teamName]);

    return (
        <div className="w-full">
            <div className="px-2 sm:px-4 pt-2 sm:pt-3">
                <WidgetTitle linkUrl={getUrlByContext('/games/', teamName)} linkTitle="Календарь" title="Матчи"/>
            </div>
            <CalendarCarousel matches={mathcList} lastItemLink={getUrlByContext('/games/', teamName)} />
        </div>
    );
}